'use client';

import React, { ElementType } from 'react';
import { Box, SvgIcon, SxProps, Theme, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
interface LoadingStateProps {
  desc?: string;
  icon?: ElementType;
  iconStyles?: SxProps<Theme>;
}
function LoadingState({
  icon,
  iconStyles,
  desc
}: LoadingStateProps) {
  return <Box sx={{
    width: '100%',
    maxWidth: {
      md: 450,
      xs: 340
    },
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    overflow: 'hidden',
    mx: 'auto',
    py: 'var(--spacing_l_nudge)',
    textAlign: 'center',
    gap: 'var(--spacing_m)',
    flexWrap: 'nowrap'
  }} data-sentry-element="Box" data-sentry-component="LoadingState" data-sentry-source-file="LoadingState.tsx">
      {icon ? <SvgIcon color='inherit' component={icon} sx={{
      ...iconStyles
    }} /> : <CircularProgress size={20} />}
      {desc && <Typography variant='bodyLargeStrong__Wallfund' color='text.text'>
          {desc}
        </Typography>}
    </Box>;
}
export default LoadingState;